import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useModal, useStore, useToast, usePopup, usePage } from "@/comn/hooks"; // hook
import {
    BASE,
    URLS,
    APIS,
    SG_XTRN_USR_CHG_HIST_DTL_LIST,
    SF_XTRN_USR_CHG_HIST_SRCH,
} from "@/tra/tancis/ptli/usr/xtrnusrhist/service/PtliXtrnUsrChgHistService";

/*
 * Customs employee change history details
 * !== 세관직원변경이력 상세==!
 */
export const PTLI0923002Q = (): JSX.Element => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid } = usePage({
        auth: ["auth_ptli0015"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const { xtrnUsrIdntfNo, lcneUsrYn } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Search customs employee change history !== 세관직원변경이력 검색 ==!
        xtrnUsrChgHistSrch: useForm({
            defaultSchema: SF_XTRN_USR_CHG_HIST_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Customs employee change history list !== 세관직원변경이력 상세 목록 ==!
        cstmOfcrChgHistDtlList: useGrid({
            defaultSchema: SG_XTRN_USR_CHG_HIST_DTL_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Check detailed list of customs employee change history !== 세관직원변경이력 상세 목록 조회 ==!
        getxtrnUsrChgHistDtlList: useFetch({
            api: (page = grid.cstmOfcrChgHistDtlList.page) => {
                return APIS.getXtrnUsrChgHistDtlList(
                    form.xtrnUsrChgHistSrch.getValues(),
                    page,
                    grid.cstmOfcrChgHistDtlList.size,
                );
            },
            enabled: comnUtils.isEmpty(form.xtrnUsrChgHistSrch.errors) && form.xtrnUsrChgHistSrch.isSubmitted,
            key: [grid.cstmOfcrChgHistDtlList.page, grid.cstmOfcrChgHistDtlList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.xtrnUsrChgHistSrch.getValues(),
                    page: grid.cstmOfcrChgHistDtlList.page,
                    size: grid.cstmOfcrChgHistDtlList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Check detailed list of customs employee change history !== 세관직원변경이력 상세 목록 조회 ==!
        getxtrnUsrChgHistDtlList: () => {
            form.xtrnUsrChgHistSrch.handleSubmit(
                (data) => {
                    grid.cstmOfcrChgHistDtlList.setPage(0);
                    fetch.getxtrnUsrChgHistDtlList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
    };

    const render = {
        cell: {
            usrNm: (props: any, context: any) => {
                debugger;
                const { rowValues, value } = props;
                if (rowValues.usrNmMdfyYn == "Y") {
                    context.textColor = "red";
                }
                return <div>{value}</div>;
            },
            xtrnUsrIdntfNo: (props: any, context: any) => {
                const { rowValues, value } = props;
                if (rowValues.xtrnUsrIdntfNoMdfyYn == "Y") {
                    context.textColor = "red";
                }
                return <div>{value}</div>;
            },
            usrMoblNo: (props: any, context: any) => {
                const { rowValues, value } = props;
                if (rowValues.usrMoblNoMdfyYn == "Y") {
                    context.textColor = "red";
                }
                return <div>{value}</div>;
            },
            usrEmlAddr: (props: any, context: any) => {
                const { rowValues, value } = props;
                if (rowValues.usrEmlAddrMdfyYn == "Y") {
                    context.textColor = "red";
                }
                return <div>{value}</div>;
            },
            rsdtAddr: (props: any, context: any) => {
                const { rowValues, value } = props;
                if (rowValues.rsdtAddrMdfyYn == "Y") {
                    context.textColor = "red";
                }
                return <div>{value}</div>;
            },
            usrStatCdNm: (props: any, context: any) => {
                const { rowValues, value } = props;
                if (rowValues.usrStatCdMdfyYn == "Y") {
                    context.textColor = "red";
                }
                return <div>{value}</div>;
            },
        },
    };

    useEffect(() => {
        form.xtrnUsrChgHistSrch.setValue("xtrnUsrIdntfNo", xtrnUsrIdntfNo);
        form.xtrnUsrChgHistSrch.setValue("lcneUsrYn", lcneUsrYn);
        handler.getxtrnUsrChgHistDtlList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.cstmOfcrChgHistDtlList.grid}
                            data={fetch.getxtrnUsrChgHistDtlList.data?.usrHistDtlList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout.Left>
                <Button
                    role="list"
                    onClick={() => {
                        navigate(URLS.ptli0923001q);
                    }}
                ></Button>
            </Layout.Left>
        </Page>
    );
};
